export default "__VITE_ASSET__406e0085__"